export const getItems = (state, getters) => {
  if (!Array.isArray(state.items)) return []
  return state.items.map((item) => {
    item._rowVariant = ''
    item._showDetails = item._showDetails || false
    return item
  })
}

export const getItemById = (state) => (id) => {
  return state.items.find(item => item.id === id)
}

export const getEnableUIDs = (state, getters) => {
  return getters.getItems
          .filter(x => !getters.isDisabled(x))
          .map(x => x._uid)
}

export const getSelectedItems = (state, getters) => {
  return getters.getItems
          .filter(x => getters.isSelected(x))
}

export const getSelectedItem = (state, getters) => {
  return getters.getItems
          .filter(x => getters.isSelected(x))[0]
}

export const getSelectedUIDs = state => {
  return state.selection
}

export const getSelectedUID = state => {
  return state.selection[0]
}

export const isDisabled = state => (item) => {
  if (!state.disabled) return false
  return state.disabled(item)
}

export const isEditable = state => (item) => {
  if (!state.editable) return true
  return state.editable(item)
}

export const isSelected = state => (item) => {
  return item && state.selection.some(x => x === item._uid)
}

export const isEditing = (state, getters) => {
  return getters.getItems.some(x => x._showDetails === true) || getters.getSelectedUID === 'new'
}

export const allSelected = (state, getters) => {
  return state.items.reduce((acc, item) => {
    if (!acc) return false
    return getters.isDisabled(item)
            ? true
            : getters.isSelected(item)
  }, true)
}

export const searching = state => {
  return state.target
}
